import { RowData } from "../types";
import { fieldValidators } from "../utils/excelUtils";

export const handleValidate = (data: RowData[]): RowData[] => {
	return data.map((row) => {
		let mensagem = typeof row.mensagem === "string" ? row.mensagem.trim() : "";
		let status = row.status === "inválido" ? "inválido" : "validado";
		const seenMessages = new Set(mensagem.split(" | ").filter(Boolean));

		for (const key in fieldValidators) {
			const { aliases, validators } = fieldValidators[key];
			const foundAlias = aliases.find((alias: string) => row.hasOwnProperty(alias));

			if (!foundAlias) continue;

			const originalValue = row[foundAlias];

			for (const validateFn of validators) {
				const result = validateFn(originalValue);
				// Atualiza todos os aliases com o valor validado
				aliases.forEach((alias: string) => {
					if (row[alias] != null) row[alias] = result.value;
				});

				if (result.status === "invalid" && result.message) {
					status = "inválido";
					if (!seenMessages.has(result.message)) {
						seenMessages.add(result.message);
					}
				}
			}
		}

		const novaMensagem = Array.from(seenMessages).join(" | ");

		return {
			...row,
			status,
			mensagem: novaMensagem,
		};
	});
};
